import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import MobileHome from "./MobileHome";
import MobileBottomNav from "./MobileBottomNav";
import MobileChauffeur from "./MobileChauffeur";
import MobileRentals from "./MobileRentals";
import BookRental from "../pages/BookRental";
import BookRide from "../pages/BookRide";
import BookingShare from "../pages/BookingShare";

/**
 * MobileApp — root of the mobile PWA experience.
 * - Renders mobile-only screens under /m/*
 * - Adds a persistent bottom nav
 */
export default function MobileApp() {
  return (
    <div className="mobile-app min-h-screen bg-[#071A2F] text-white antialiased">
      <RoutedShell />
      <MobileBottomNav />
    </div>
  );
}

const pageVariants = {
  initial: { opacity: 0, y: 24, filter: "blur(6px)" },
  animate: { opacity: 1, y: 0, filter: "blur(0px)" },
  exit:    { opacity: 0, y: -18, filter: "blur(4px)" },
};
const pageTransition = { duration: 0.42, ease: [0.16, 1, 0.3, 1] };

function Page({ children }) {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}

function RoutedShell() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/m" element={<Page><MobileHome /></Page>} />
        <Route path="/m/chauffeur" element={<Page><MobileChauffeur /></Page>} />
        <Route path="/m/rentals" element={<Page><MobileRentals /></Page>} />
        {/* Full digital rental contract + chauffeur booking + status page —
            reachable on mobile so RESERVE opens the full flow instead of
            being swallowed by the wildcard below. */}
        <Route path="/book/rental/:vehicleId" element={<Page><BookRental /></Page>} />
        <Route path="/book/ride/:vehicleId" element={<Page><BookRide /></Page>} />
        <Route path="/b/:bookingId" element={<Page><BookingShare /></Page>} />
        <Route path="/girls-night" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/m" replace />} />
      </Routes>
    </AnimatePresence>
  );
}
